import { useTranslation } from 'react-i18next';

import { namespaces } from '@sternum/web/services/i18n';

import { Container, Description, Title } from './NoSearchResultsState.styles';

export interface NoSearchResultsStateProps {}

export function NoSearchResultsState() {
  const { t } = useTranslation(namespaces.appContainerWithMenu);

  return (
    <Container>
      <Title>{t('noDashboardSearchResultsTitle')}</Title>
      <Description>{t('noDashboardSearchResultsDescription')}</Description>
    </Container>
  );
}
